"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _FallbackComponent = _interopRequireDefault(require("./FallbackComponent"));

var _ErrorBoundary = _interopRequireDefault(require("./ErrorBoundary"));

var _StoryblokEditable = _interopRequireDefault(require("../StoryblokEditable"));

var _ComponentRegistry = _interopRequireDefault(require("../../context/ComponentRegistry"));

/**
 *
 * StoryblokComponent
 *
 */

/* eslint-disable no-underscore-dangle */
function StoryblokComponent(props) {
  var content = props.content,
      component = props.component,
      _props$editable = props.editable,
      editable = _props$editable === void 0 ? true : _props$editable,
      rest = (0, _objectWithoutProperties2["default"])(props, ["content", "component", "editable"]);
  var registry = (0, _react.useContext)(_ComponentRegistry["default"]);

  if (!registry) {
    return _react["default"].createElement(_FallbackComponent["default"], {
      type: content.component,
      error: new Error('StoryblokComponent: The ComponentRegistry is missing. Please wrap all StoryblokComponents into StoryblokComponentProvider.')
    });
  }

  var componentName = component || content.component;
  var Component = registry.get(componentName);
  var Editable = registry.getEditable(componentName);
  var hasEditable = !!content._editable;

  if (!Component) {
    return _react["default"].createElement(_FallbackComponent["default"], {
      type: content.component,
      error: new Error("StoryblokComponent: Couldnt find registered Component for `".concat(componentName, "`"))
    });
  }

  if (hasEditable) {
    return _react["default"].createElement(_StoryblokEditable["default"], {
      content: editable ? content : {}
    }, Editable ? _react["default"].createElement(_ErrorBoundary["default"], {
      content: content
    }, _react["default"].createElement(Editable, {
      content: content
    }, function (transformed) {
      return _react["default"].createElement(Component, (0, _extends2["default"])({
        content: transformed
      }, rest));
    })) : _react["default"].createElement(_ErrorBoundary["default"], {
      content: content
    }, _react["default"].createElement(Component, (0, _extends2["default"])({
      content: content
    }, rest))));
  }

  return _react["default"].createElement(_ErrorBoundary["default"], {
    content: content
  }, _react["default"].createElement(Component, (0, _extends2["default"])({
    content: content
  }, rest)));
}

var _default = StoryblokComponent;
exports["default"] = _default;